/**
 * WebGLChart Formatters
 * Date and time formatting utilities
 */

import { LOCALE } from '../constants';

/**
 * Format timestamp for axis display
 */
export function formatAxisTime(timestamp: number): string {
  // Guard against invalid timestamps
  if (!Number.isFinite(timestamp) || timestamp <= 0) {
    return '--';
  }

  const d = new Date(timestamp * 1000);

  // Check if date is valid
  if (isNaN(d.getTime())) {
    return '--';
  }

  return new Intl.DateTimeFormat(LOCALE, {
    day: "2-digit",
    month: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).format(d);
}

/**
 * Format timestamp for display with full date
 */
export function formatDisplayTime(timestamp: number): string {
  // Guard against invalid timestamps
  if (!Number.isFinite(timestamp) || timestamp <= 0) {
    return '--';
  }

  const d = new Date(timestamp * 1000);

  // Check if date is valid
  if (isNaN(d.getTime())) {
    return '--';
  }

  return new Intl.DateTimeFormat(LOCALE, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).format(d);
}

/**
 * Format number for locale display
 */
export function formatNumber(value: number): string {
  if (!Number.isFinite(value)) return '--';

  // Use appropriate precision based on magnitude
  if (Math.abs(value) < 0.01) {
    return value.toExponential(2);
  } else if (Math.abs(value) < 1) {
    return value.toLocaleString(LOCALE, { maximumFractionDigits: 4 });
  } else if (Math.abs(value) < 1000) {
    return value.toLocaleString(LOCALE, { maximumFractionDigits: 2 });
  } else {
    return value.toLocaleString(LOCALE, { maximumFractionDigits: 0 });
  }
}
